import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Constants } from '@base/src/app/models/constants';
import { Filter } from '@base/src/app/models/filters.model';
import { QRButton } from '@base/src/app/models/qr-button.model';
import { QRDropdown } from '@base/src/app/models/qr-dropdown.model';
import { QRIcon } from '@base/src/app/models/qr-icon.model';
import { FilterList } from '@base/src/app/pages/stats/stats-list/models/filter-list.model';
import { DownloadCatchmentsListService } from '@base/src/app/pages/stats/stats-list/services/download-catchments-list.service';
import { UtilsService } from '@base/src/app/services/utils.service';

@Component({
  selector: 'app-dialog-download-list',
  templateUrl: './dialog-download-list.component.html',
  styleUrls: ['./dialog-download-list.component.scss'],
})
export class DialogDownloadListComponent implements OnInit {
  @Input() filters!: FilterList;
  @Output() change: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();

  selectedOption: 'first' | 'second' | 'third' = 'first';
  icons: any[] = [];
  readonly ICON_CHECK: string = Constants.ICONS.CHECK;
  readonly ICON_COLOR_SUCCESS_700: string = QRIcon.COLOR_SUCCESS_700;

  buttonGoBack: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Volver',
  };

  buttonDownload: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Descargar',
  };

  dropdownYears: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Año',
    options: [],
  };

  dropdownMonths: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Mes',
    options: [],
  };

  date = new Date();
  currentMonth = this.date.getMonth();
  currentYear = this.date.getFullYear();
  selectedMonth: string = '';
  yearSelected: string = '';
  filtersToDownload: any = {};

  constructor(
    public readonly utils: UtilsService,
    private readonly downloadService: DownloadCatchmentsListService
  ) {}

  ngOnInit(): void {
    this.setCurrentMonth();
    this.setDropdownYear();
  }

  setCurrentMonth() {
    const MONTHS = this.utils.months.map((month) => month.spanishName);
    const AVAILABLE_MONTHS = MONTHS.slice(0, this.currentMonth + 1);

    this.dropdownMonths.options = [];

    this.dropdownMonths = {
      ...this.dropdownMonths,
      options: AVAILABLE_MONTHS,
    };

    this.selectedMonth = MONTHS[this.currentMonth];
  }

  setAllMonths() {
    const MONTHS = this.utils.months.map((month) => month.spanishName);

    this.dropdownMonths = {
      ...this.dropdownMonths,
      options: MONTHS,
    };
  }

  setDropdownYear() {
    this.dropdownYears = {
      ...this.dropdownYears,
      options: this.utils.getYears(2013),
    };

    this.yearSelected = this.currentYear.toString();
  }

  dropdownMonthChange(selected: string | string[] | undefined): void {
    this.selectedMonth = String(selected);
  }

  dropdownYearChange(selected: string | string[] | undefined): void {
    this.yearSelected = String(selected);

    if (this.yearSelected !== this.currentYear.toString()) {
      this.setAllMonths();
    } else {
      this.setCurrentMonth();
    }
  }

  downloadProcess(): void {
    if (this.selectedOption === 'first') {
      this.formatDownloadFilters(this.filters);
      this.downloadService.downloadList(this.filtersToDownload);
      this.change.emit(true);
    } else if (this.selectedOption === 'second') {
      const MONTH_INDEX = this.utils.months.findIndex(
        (m) => m.spanishName === this.selectedMonth
      );
      const MONTH = (MONTH_INDEX + 1).toString().padStart(2, '0');

      const BODY = {
        agencyId: this.filters.idAgency,
        userId: this.filters.userId,
        month: MONTH,
        year: this.yearSelected,
      };

      this.downloadService.downloadList(BODY);
      this.change.emit(true);
    } else if (this.selectedOption === 'third') {
      const BODY = {
        agencyId: this.filters.idAgency,
        userId: this.filters.userId,
        month: null,
        year: this.yearSelected,
      };

      this.downloadService.downloadList(BODY);
      this.change.emit(true);
    }
  }

  formatDownloadFilters(filters: FilterList): void {
    this.filtersToDownload = {
      agencyId: filters.idAgency,
      userId: filters.userId,
      month: null,
      year: null,
      initDate: filters.startPeriodDate,
      endDate: filters.endPeriodDate,
      type: filters.operationType,
      address: filters.address,
      mlsId: filters.mlsid,
      agent:
        filters.organizationIdVendedor === ''
          ? null
          : filters.organizationIdVendedor,
      initCloseDate: filters.startCloseDate,
      endCloseDate: filters.endCloseDate,
      initExpirationDate: filters.startExpirationDate,
      endExpirationDate: filters.endExpirationDate,
      operationType: filters.operationType,
      credit: filters.credit,
      statisticsTypeId: filters.statisticsTypeId,
      statisticsState: filters.statisticsState,
      catchmentState: filters.catchmentState,
    };
  }

  closeDialog(): void {
    this.close.emit(true);
  }
}
